import { AsyncThunk, createAsyncThunk } from '@reduxjs/toolkit';
import api from '@app/network/apiClient';
import { LoginData } from './LoginData';
import { SessionAPIsI, SetUserDataThunk } from '../types';
import { ensureCsrfLoaded } from '../csrfCookie';

const getLoginThunk = (
  setUserData: SetUserDataThunk,
  sessionAPIs: SessionAPIsI
): AsyncThunk<void, LoginData, Record<string, never>> =>
  createAsyncThunk('login', async (data: LoginData, { dispatch }) => {
    await ensureCsrfLoaded();

    const response = await api.post(sessionAPIs.login, data);
    const isAccountSuspended = response.data.errors?.is_suspended;

    if (isAccountSuspended) {
      throw new Error(response.data.message);
    }

    if (response.status >= 400) {
      throw new Error('Invalid response!');
    }

    await dispatch(setUserData(response.data.data));
  });

export default getLoginThunk;
